<template>
  <div class="d-flex">
    <e-btn
      icon
      size="L"
      class="mr-2"
      :variant="modelValue === ViewMode.Table ? 'tonal' : 'ghost'"
      @click="setViewMode(ViewMode.Table)"
    >
      <e-icon name="table" />
    </e-btn>
    <e-btn
      icon
      size="L"
      :variant="modelValue === ViewMode.Grid ? 'tonal' : 'ghost'"
      @click="setViewMode(ViewMode.Grid)"
    >
      <e-icon name="grid" />
    </e-btn>
  </div>
</template>

<script setup lang="ts">
import { EBtn, EIcon } from '@/core/components/ui';
import { ViewMode } from '@/core/types/components/helps';

defineProps<{
  modelValue: ViewMode;
}>();

const emit = defineEmits<{
  (event: 'update:modelValue', value: ViewMode): void;
}>();

const setViewMode = (viewMode: ViewMode) => {
  emit('update:modelValue', viewMode);
};
</script>

<style scoped lang="scss"></style>
